import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { FormGroup } from '@angular/forms';
import { iMessage } from './imessage';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

const NODE_TYPE = 'iMessage';

@Component({
  selector: 'app-imessage',
  templateUrl: './imessage.component.html',
  styleUrls: ['./imessage.component.scss'],
})
export class ImessageComponent extends NodeBuilder implements OnInit {

  iMessageForm: FormGroup = undefined;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.iMessageForm = iMessage.toForm(stepData, this.canEdit);

    if (this.iMessageForm.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep();
      this.iMessageForm.get('next').setValue(this.newStep);
    }
  }

  get getStepData(): {} {
    const imessage = new iMessage();
    const rawValue = this.iMessageForm.getRawValue();
    imessage.setMenu(rawValue);
    const nodeData = imessage.nodeData;
    nodeData['next'] = rawValue.next;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.iMessageForm.markAllAsTouched();
    return this.iMessageForm.valid;
  }

  setImage(event, form) {
    form.get('imageReference').setValue(event);
  }
}
